import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { set, unset } from "lodash-es";
import { DefaultPage, DefaultPageSize } from "const/pagination";
import { PropressaleQueryWhere } from "lib/api";

import { RootState } from "store";

export const SALES_LIST_SLICE_NAME = "sales";

interface Pagination {
    page: number;
    pageSize: number;
}

interface SalesListSliceState {
    filters: PropressaleQueryWhere;
    pagination: Pagination;
}

const initialState: SalesListSliceState = {
    filters: {},
    pagination: { page: DefaultPage, pageSize: DefaultPageSize },
};

export const salesListSlice = createSlice({
    name: SALES_LIST_SLICE_NAME,
    initialState,
    reducers: {
        setFilter: (
            state,
            action: PayloadAction<{
                field: keyof PropressaleQueryWhere;
                value: any;
            }>,
        ) => {
            const { field, value } = action.payload;
            // to accept false as filter values
            if (value || value === false) {
                // to set and unset nested state fields
                set(state.filters, field, value);
            } else {
                unset(state.filters, field);
            }
            state.pagination.page = DefaultPage;
        },
        setPage: (state, action: PayloadAction<number>) => {
            const page = action.payload;
            state.pagination.page = page;
        },
        setPageSize: (state, action: PayloadAction<number>) => {
            const pageSize = action.payload;
            state.pagination.pageSize = pageSize;
            state.pagination.page = DefaultPage;
        },
    },
});

export const { setFilter, setPage, setPageSize } = salesListSlice.actions;

export const selectSalesListSlice = (state: RootState) => state[SALES_LIST_SLICE_NAME];
export const selectSalesListFilters = (state: RootState) => selectSalesListSlice(state).filters;

export default salesListSlice.reducer;
